const params = new URLSearchParams(window.location.search)
export const queryCustomerId = params.get('customerId')
export const queryFlow = params.get('flow')
export const queryStudioId = params.get('studioid')
export const queryMeetingTypeId = params.get('meetingtypeid')
export const queryFake = params.get('fake')

export const iframed = window.self === window.top

/* eslint-disable-next-line no-underscore-dangle */
const authUser = window.__OMNI__ || {}

export const user = {
  name: authUser.payload?.['https://nobiadigital.com/name'],
  email: authUser.payload?.['https://nobiadigital.com/email'],
  roles: authUser.payload?.['https://nobiadigital.com/roles'] || [],
  access_token: authUser.access_token || [],
}

export const isCustomer = user.roles.includes('customer')
export const isDesigner = user.roles.includes('staff')
